module.exports = __webpack_public_path__ + "static/img/19_phase_function_Paper_PointsHejduk_Prediction.3773039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19_phase_function_Paper_PointsHejduk_Prediction.png
// module id = /XCh
// module chunks = 0